// extracted by mini-css-extract-plugin
export default {"toast":"ToastBody-module--toast--3YDcg"};